
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { KeycloakAuthService } from 'src/app/auth/keycloak-auth.service';
import { selectAuthLoggedIn, selectTotalFavorites, selectDealerFname } from 'src/app/common/store/state/app.state';

@Component({
    selector: 'app-sticky-footer',
    templateUrl: './sticky-footer.component.html',
    styleUrls: ['./sticky-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, RouterLink, MatBadgeModule]
})
export class StickyFooterComponent implements OnInit {

    loggedIn$: Observable<boolean>; 
    totalFavorites$: Observable<number>;
    fname$: Observable<string>;

    constructor(
        private store: Store,
        private router: Router,
        private authService: KeycloakAuthService
        ) {
          this.loggedIn$ = store.select(selectAuthLoggedIn);
          this.totalFavorites$ = store.select(selectTotalFavorites);
          this.fname$ = store.select(selectDealerFname);
    
        }
    
      ngOnInit(): void {
          
      }

      getLoggedInChar(): string {

        return this.authService.getLoggedInChar();
      }

      isLoggedIn(): boolean {

        return this.authService.isLoggedIn();
      }
    
      onResize(event: any) {
     
        
      }
    
    }
    